/**
 * EventTagPill — one tag on a calendar event (#680), the same pill on every
 * surface that shows an event's tags (the quick view and the full event page).
 * Read-only; editing goes through TagInput.
 *
 * Tinted from the tag's own colour: ~12% of it behind, and the colour mixed
 * 70/30 with the ink (#0C0A09) for the text, so a light tag colour stays
 * legible. Mixed here rather than with CSS color-mix(), which older Safari
 * drops. A tag with no (or a non-hex) colour is violet, like the design.
 */
const HEX6 = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i;
const INK = [12, 10, 9];
const FALLBACK = { background: '#EFEAFE', color: '#3B0DBE' };

export function tagPillStyle(color) {
    const m = HEX6.exec(color || '');
    if (!m) return FALLBACK;
    const hex = m.slice(1).map((h, i) => Math.round(parseInt(h, 16) * 0.7 + INK[i] * 0.3).toString(16).padStart(2, '0'));
    return { background: `${color}1F`, color: `#${hex.join('')}` };
}

export function EventTagPill({ tag }) {
    return (
        <span
            className="inline-flex items-center h-6 px-2.5 rounded-md text-[12.5px] font-medium"
            style={tagPillStyle(tag.color)}
            data-testid={`event-tag-${tag.tag_id}`}
        >
            {tag.name}
        </span>
    );
}
